import { render, staticRenderFns } from "./ProductSpecsView.vue?vue&type=template&id=18373304"
import script from "./ProductSpecsView.vue?vue&type=script&lang=js"
export * from "./ProductSpecsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports